export const RECEIVED_UPLOAD = "RECEIVED_UPLOAD"



// WEBPACK FOOTER //
// ./src/types/actions/upload.js